<template>
    <div style="height: 100%">
        <iframe :src="fileurl"
                style="width: 100%;height: 100%;background: #fff">
        </iframe>
    </div>
</template>

<script>
    export default {
        name: "linkEnv",
        props:{
            fileurl:String,
        },
    }
</script>

<style scoped>

</style>